/**
 * @file navigation.js
 * @description 공통 내비게이션과 페이지 메타 정보를 정의합니다.
 * @used-in components/common/Header.jsx, utils/routing.js
 * @migrated-from src/App.js
 */


export const navItems = [
  { id: 'home', label: 'Home', href: '/' },
  {
    id: 'company',
    label: 'Company',
    href: '/company/ceo.html',
    children: [
      { id: 'ceo', label: '인사말', href: '/company/ceo.html' },
      { id: 'about', label: '회사소개', href: '/company/about.html' },
      { id: 'customers', label: '주요 고객사', href: '/company/customers.html' },
      { id: 'maintenance', label: '유지보수', href: '/company/maintenance.html' },
    ],
  },
  {
    id: 'solution',
    label: 'Solution',
    href: '/solution/withgmp.html',
    children: [
      { id: 'withgmp',   label: 'withGMP',     href: '/solution/withgmp.html' },
      { id: 'withaigmp', label: 'with-AI-GMP', href: '/solution/withaigmp.html' },
    ],
  },
  { id: 'news', label: 'News', href: '/news/index.html' },
  {
    id: 'cs',
    label: 'CS',
    href: '/cs/faq.html',
    children: [
      { id: 'faq', label: 'FAQ', href: '/cs/faq.html' },
      { id: 'contact', label: '문의하기', href: '/contact' },
    ],
  },
];

export const pageMeta = {
  companyAbout: { title: '회사소개', trail: ['Company', '회사소개'] },
  companyCeo: { title: '인사말', trail: ['Company', '인사말'] },
  companyHistory: { title: '연혁', trail: ['Company', '연혁'] },
  companyCustomers: { title: '주요 고객사', trail: ['Company', '주요 고객사'] },
  companyMaintenance: { title: '유지보수', trail: ['Company', '유지보수'] },
  solution: { title: 'Solution', trail: ['Solution'] },
  newsList: { title: 'News', trail: ['News'] },
  newsDetail: { title: 'News Detail', trail: ['News'] },
  faq: { title: 'FAQ', trail: ['CS', 'FAQ'] },
  contact: { title: '문의하기', trail: ['CS', '문의하기'] },
  notFound: { title: 'Page Not Found', trail: ['Not Found'] },
};
